module.exports = __webpack_public_path__ + "static/media/teygja_fotapressa.9fbab948.png";